import React from "react"
import { graphql, Link } from "gatsby"

import Collapse, { Panel } from "rc-collapse"

import '../css/faq-accordions.css';

function PanelHeader({ number, title }) {

  return (
    <React.Fragment>
    { number &&
      <strong>{number}. </strong>
    }
     {title}
    </React.Fragment>
  );
}

export function FaqGroup({ title, group, offsetCount=0, classes=`col-md-6` }) {
  return (
    <div className={classes}>
      { title &&
        <h2>{title}</h2>
      }
      <Collapse accordion={true}>
        { group &&
          group.map((faq, index) => { index += offsetCount;
            return (
              <React.Fragment key={faq.id}>
                <Panel header={<PanelHeader number={++index} title={faq.title} />} headerClass="" className="opensingle">
                  <div className="maincopy" dangerouslySetInnerHTML={{ __html: faq.excerpt }} />
                  <Link to={faq.link}>Read More</Link>
                </Panel>
              </React.Fragment>
            )
          })
        }
      </Collapse>
    </div>
  )
}

const FAQAccordions = ({ title, faqs }) => {
  let half, firstHalf, secondHalf;
  if(faqs) {
    half = Math.ceil(faqs.length / 2);

    firstHalf = faqs.slice(0, half);
    secondHalf = faqs.slice(-half);
  }

  return (
    <div className="container faqContainer">
      <div className="grid smallGrid">
        <div className="col-sm-12 maincopy">
          <h2>Frequently Asked Questions</h2>
          <hr />
        </div>

        <FaqGroup group={firstHalf} />
        <FaqGroup group={secondHalf} offsetCount={half} />

      </div>
    </div>
  )
}

export default FAQAccordions